var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"theme-background theme-border theme-text d-inline-flex align-center pl-1 pr-1",class:_vm.substitute ? 'player-entry-substitute' : 'player-entry',attrs:{"depressed":"","tile":"","flat":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }